import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Ambiente = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const ambientes = pessoal?.Ambientes ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalAmbiente',
      id: item?.id,
      pessoal_id: pessoal?.id,
      ambiente_id: item?.ambiente_id || null,
      inivalid: item?.inivalid || null,
      fimvalid: item?.fimvalid || null,
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Identificação do Ambiente de Trabalho" disableMargin />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            name="ambiente_id"
            control={control}
            label="Tipo de Ambiente"
            options={drops?.Ambiente}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            control={control}
            name="inivalid"
            label="Data de Início"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            control={control}
            name="fimvalid"
            label="Data de Término"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Ambientes de Trabalho"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Ambiente')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={ambientes}
          columns={[
            {
              field: 'ambiente',
              headerName: 'Tipo',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'inivalid',
              headerName: 'Data de Início',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'fimvalid',
              headerName: 'Data de Término',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Ambiente')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalAmbiente', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Ambiente;
